import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

export const ApiKeyField = ({ draft, onSave }) => {
  const [open, setOpen] = useState(false);
  const [key, setKey] = useState('');
  const save = async () => { if (await onSave(key)) { setKey(''); setOpen(false); } };
  return (
    <div className="space-y-2" data-testid="email-api-key">
      <Label className="text-xs">Resend API Key</Label>
      <div className="flex items-center gap-2 text-sm">
        <KeyRound className="w-4 h-4 text-neutral-500" />
        <span data-testid="email-key-hint">{draft.key_hint ? `Saved (${draft.key_hint})` : 'Not set'}</span>
        {!open && <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="email-key-replace">{draft.key_hint ? 'Replace API Key' : 'Add API Key'}</Button>}
      </div>
      {open && (
        <div className="flex gap-2">
          <Input type="password" autoComplete="off" value={key} onChange={(e) => setKey(e.target.value)} placeholder="re_…" data-testid="email-key-input" />
          <Button size="sm" disabled={key.trim().length < 10} onClick={save} data-testid="email-key-save">Save</Button>
          <Button size="sm" variant="ghost" onClick={() => { setOpen(false); setKey(''); }} data-testid="email-key-cancel">Cancel</Button>
        </div>
      )}
      <p className="text-xs text-neutral-500">Stored encrypted for this website only. It is never shown again and is not copied if the site is cloned.</p>
    </div>
  );
};
